export interface Building {
    region: string;
    country: string;
    city: string;
    building: string;
}

export interface FinanceCode {
    code: string;
    description: string;
}

export const CATALOGICAL_DOMAINS = {
    BUILDINGS: "hworderbuildings",
    FINANCE_CODES: "hworderfincodes",
} as const;
